import { StoreProduct } from '../types';

export const DEFAULT_STORE_PRODUCTS: StoreProduct[] = [
  {
    id: 'prod-1',
    title: 'Figure Bandai Ichiban Kuji One Piece Luffy Gear 5 (Masterlise)',
    category: 'Figures & Colecionáveis',
    priceJpy: 8500,
    originalPriceJpy: 9800,
    image: 'https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?w=800&auto=format&fit=crop&q=80',
    condition: 'Novo/Lacrado',
    location: 'Pronta Entrega no Depósito Saitama',
    weightKg: 0.85,
    stock: 4,
    rating: 5.0,
    reviewsCount: 3,
    salesCount: 42,
    orderIndex: 0,
    description: 'Figure oficial de alta precisão lançada exclusivamente no Japão via Ichiban Kuji. Escultura Masterlise detalhada do Monkey D. Luffy em sua forma Gear 5.',
    tags: ['One Piece', 'Luffy', 'Ichiban Kuji', 'Bandai', 'Masterlise'],
    featured: true,
    freeShipping: true,
    reviews: [
      {
        id: 'rev-1-1',
        userName: 'Rodrigo S.',
        userSuite: '8821',
        rating: 5,
        comment: 'Chegou perfeitamente embalado no depósito e o Gear 5 é simplesmente impecável!',
        createdAt: '2026-07-20T14:30:00Z',
        verifiedPurchase: true
      },
      {
        id: 'rev-1-2',
        userName: 'Mariana K.',
        userSuite: '4310',
        rating: 5,
        comment: 'Preço muito mais em conta que no Brasil. Qualidade japonesa original.',
        createdAt: '2026-07-28T10:15:00Z',
        verifiedPurchase: true
      }
    ]
  },
  {
    id: 'prod-2',
    title: 'Good Smile Company Nendoroid Anya Forger (Spy x Family #1900)',
    category: 'Figures & Colecionáveis',
    priceJpy: 6200,
    originalPriceJpy: 6800,
    image: 'https://images.unsplash.com/photo-1563089145-599997674d42?w=800&auto=format&fit=crop&q=80',
    condition: 'Novo/Lacrado',
    location: 'Pronta Entrega no Depósito Saitama',
    weightKg: 0.45,
    stock: 6,
    rating: 4.9,
    reviewsCount: 2,
    salesCount: 38,
    orderIndex: 1,
    description: 'Nendoroid original da Anya Forger com múltiplas placas de rosto intercambiáveis (incluindo o famoso rosto de deboche "heh") e o ursinho Chimera.',
    tags: ['Spy x Family', 'Anya', 'Nendoroid', 'Good Smile'],
    featured: true,
    reviews: [
      {
        id: 'rev-2-1',
        userName: 'Felipe Mendes',
        userSuite: '1102',
        rating: 5,
        comment: 'Anya muito fofa! A caixinha veio sem nenhum detalhe.',
        createdAt: '2026-08-01T18:20:00Z',
        verifiedPurchase: true
      }
    ]
  },
  {
    id: 'prod-3',
    title: 'Game Boy Advance SP Pearl Blue (Japonês Conservado em Caixa)',
    category: 'Games & Retro',
    priceJpy: 14500,
    originalPriceJpy: 16000,
    image: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=800&auto=format&fit=crop&q=80',
    condition: 'Seminovo Excelente',
    location: 'Pronta Entrega no Depósito Saitama',
    weightKg: 0.50,
    stock: 2,
    rating: 4.8,
    reviewsCount: 2,
    salesCount: 19,
    orderIndex: 2,
    description: 'Console Game Boy Advance SP modelo AGS-001 cor Pearl Blue importado direto de Akihabara. Testado, higienizado, com carregador bivolt e manuais originais.',
    tags: ['Retro Game', 'Nintendo', 'Game Boy', 'Akihabara', 'Colecionável'],
    featured: true,
    reviews: [
      {
        id: 'rev-3-1',
        userName: 'Thiago B.',
        userSuite: '5590',
        rating: 5,
        comment: 'Console em estado de novo! Bateria e tela 100%. Recomendo.',
        createdAt: '2026-08-04T12:00:00Z',
        verifiedPurchase: true
      }
    ]
  },
  {
    id: 'prod-4',
    title: 'Kit 3x Protetor Solar Bioré UV Aqua Rich Watery Essence SPF50+ PA++++',
    category: 'J-Beauty & Cosméticos',
    priceJpy: 2980,
    originalPriceJpy: 3500,
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=800&auto=format&fit=crop&q=80',
    condition: 'Novo/Lacrado',
    location: 'Pronta Entrega no Depósito Saitama',
    weightKg: 0.30,
    stock: 12,
    rating: 5.0,
    reviewsCount: 3,
    salesCount: 120,
    orderIndex: 3,
    description: 'O protetor solar japonês mais vendido do mundo! Fórmula em essência à base de água super leve, sem deixar resíduos brancos. Kit promocional com 3 unidades de 70g.',
    tags: ['J-Beauty', 'Bioré', 'Skincare', 'Cosméticos', 'Japão'],
    featured: true,
    reviews: [
      {
        id: 'rev-4-1',
        userName: 'Camila P.',
        userSuite: '7734',
        rating: 5,
        comment: 'Uso diário há anos, não troco por nada. O preço do kit direto do Japão é imbatível.',
        createdAt: '2026-08-05T09:30:00Z',
        verifiedPurchase: true
      }
    ]
  },
  {
    id: 'prod-5',
    title: 'Sérum Facial Melano CC Vitamin C Premium Rohto (20ml)',
    category: 'J-Beauty & Cosméticos',
    priceJpy: 1850,
    image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=800&auto=format&fit=crop&q=80',
    condition: 'Novo/Lacrado',
    location: 'Pronta Entrega no Depósito Saitama',
    weightKg: 0.12,
    stock: 15,
    rating: 4.9,
    reviewsCount: 1,
    salesCount: 64,
    orderIndex: 4,
    description: 'Tratamento intensivo concentrado com Vitamina C e E puras. Clareia manchas de acne, uniformiza o tom da pele e combate radicais livres.',
    tags: ['Melano CC', 'Rohto', 'J-Beauty', 'Vitamina C'],
    featured: false,
    reviews: [
      {
        id: 'rev-5-1',
        userName: 'Luciana M.',
        userSuite: '2288',
        rating: 5,
        comment: 'Excelente para manchas e marcas de acne. Produto original japonês.',
        createdAt: '2026-08-08T15:45:00Z',
        verifiedPurchase: true
      }
    ]
  },
  {
    id: 'prod-6',
    title: 'Box Especial KitKat Japão (Uji Matcha + Sakura + Batata Doce 36un)',
    category: 'Doces & Snacking',
    priceJpy: 2400,
    originalPriceJpy: 2800,
    image: 'https://images.unsplash.com/photo-1582293041079-7814c2f12063?w=800&auto=format&fit=crop&q=80',
    condition: 'Novo/Lacrado',
    location: 'Pronta Entrega no Depósito Saitama',
    weightKg: 0.60,
    stock: 10,
    rating: 4.9,
    reviewsCount: 2,
    salesCount: 51,
    orderIndex: 5,
    description: 'Seleção exclusiva de sabores sazonais do KitKat japonês! Contém 36 mini sachês distribuídos em Matcha de Kyoto, Flor de Cerejeira Sakura e Batata Doce Roxa de Okinawa.',
    tags: ['Snack', 'KitKat', 'Matcha', 'Doces Japoneses'],
    featured: false,
    reviews: [
      {
        id: 'rev-6-1',
        userName: 'Gabriel R.',
        userSuite: '6612',
        rating: 5,
        comment: 'Os sabores são deliciosos, principalmente o de matcha de Kyoto.',
        createdAt: '2026-08-09T17:10:00Z',
        verifiedPurchase: true
      }
    ]
  },
  {
    id: 'prod-7',
    title: 'Camiseta BAPE A Bathing Ape Camo College Tee (Preta - Tam L)',
    category: 'Streetwear & Modas',
    priceJpy: 11800,
    originalPriceJpy: 13500,
    image: 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?w=800&auto=format&fit=crop&q=80',
    condition: 'Novo/Lacrado',
    location: 'Direto de Distribuidor Oficial JP',
    weightKg: 0.35,
    stock: 3,
    rating: 4.8,
    reviewsCount: 1,
    salesCount: 14,
    orderIndex: 6,
    description: 'Camiseta icônica da A Bathing Ape com o logo APE HEAD em estampa Camo clássica verde. 100% algodão premium pesado fabricado no Japão com etiqueta de autenticidade.',
    tags: ['BAPE', 'Streetwear', 'Harajuku', 'Moda Japonesa'],
    featured: true,
    reviews: [
      {
        id: 'rev-7-1',
        userName: 'Bruno V.',
        userSuite: '9901',
        rating: 5,
        comment: 'BAPE 100% autêntica com tag japonesa original. Chegou rápido.',
        createdAt: '2026-08-10T11:05:00Z',
        verifiedPurchase: true
      }
    ]
  },
  {
    id: 'prod-8',
    title: 'Nintendo Switch OLED Pokémon Scarlet & Violet Edition (Edição Especial)',
    category: 'Games & Retro',
    priceJpy: 38000,
    originalPriceJpy: 41000,
    image: 'https://images.unsplash.com/photo-1578303512597-81e6cc155b3e?w=800&auto=format&fit=crop&q=80',
    condition: 'Novo/Lacrado',
    location: 'Direto de Distribuidor Oficial JP',
    weightKg: 1.60,
    stock: 2,
    rating: 5.0,
    reviewsCount: 2,
    salesCount: 33,
    orderIndex: 7,
    description: 'Edição de colecionador do Nintendo Switch OLED com arte personalizada dos lendários Koraidon e Miraidon na dock e Joy-Cons temáticos.',
    tags: ['Nintendo', 'Pokémon', 'Switch OLED', 'Colecionador'],
    featured: true,
    reviews: [
      {
        id: 'rev-8-1',
        userName: 'André L.',
        userSuite: '3345',
        rating: 5,
        comment: 'A arte dessa edição é a mais bonita de todas. Vale cada centavo.',
        createdAt: '2026-08-11T13:40:00Z',
        verifiedPurchase: true
      }
    ]
  },
  {
    id: 'saint-cloth-myth-griffon-minos',
    title: 'Saint Cloth Myth Griffon Minos (Cavaleiros do Zodíaco Bandai Original)',
    category: 'Figures & Colecionáveis',
    priceJpy: 16500,
    originalPriceJpy: 19800,
    image: 'https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?w=800&auto=format&fit=crop&q=80',
    condition: 'Novo/Lacrado',
    location: 'Pronta Entrega no Depósito Saitama',
    weightKg: 0.95,
    stock: 2,
    rating: 5.0,
    reviewsCount: 3,
    salesCount: 15,
    orderIndex: 8,
    description: 'Figura de ação colecionável original Bandai Japan da linha Saint Cloth Myth, retratando o juiz do submundo Minos de Griffon com armadura metálica detalhada e peças articuladas.',
    tags: ['Saint Seiya', 'Bandai', 'Cloth Myth', 'Griffon Minos', 'Action Figures', 'Hobby', 'leilao-no-japao'],
    featured: true,
    freeShipping: true
  },
  {
    id: 'cadastro-cliente-premium',
    title: 'Cadastro & Ativação de Cliente VIP Premium Japão',
    category: 'Serviços & Assinaturas',
    priceJpy: 3980,
    originalPriceJpy: 5500,
    image: 'https://images.unsplash.com/photo-1556742049-0a67e5572263?w=800&auto=format&fit=crop&q=80',
    condition: 'Serviço Digital Imediato',
    location: 'Suíte Exclusiva Saitama',
    weightKg: 0.0,
    stock: 999,
    rating: 5.0,
    reviewsCount: 12,
    salesCount: 140,
    orderIndex: 9,
    description: 'Acesso VIP à infraestrutura logística do Japão: 60 dias de armazenamento gratuito, prioridade na pesagem, fotos extras em alta resolução de todas as encomendas e atendimento concierge por WhatsApp.',
    tags: ['VIP', 'Premium', 'Assinatura', 'Serviços'],
    featured: true
  },
  {
    id: 'cliente-atacadista',
    title: 'Plano & Habilitação de Cliente Atacadista / Revenda B2B',
    category: 'Serviços & Assinaturas',
    priceJpy: 9800,
    originalPriceJpy: 15000,
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&auto=format&fit=crop&q=80',
    condition: 'Serviço Profissional B2B',
    location: 'Depósito Saitama',
    weightKg: 0.0,
    stock: 999,
    rating: 4.9,
    reviewsCount: 8,
    salesCount: 65,
    orderIndex: 10,
    description: 'Condições especiais para lojistas e revendedores: taxas reduzidas de consolidação para caixas volumosas, assessoria para fornecedores de atacado em Akihabara e suporte para importação formal.',
    tags: ['Atacado', 'B2B', 'Revenda', 'Serviços'],
    featured: true
  },
  {
    id: 'importa-facil-japao',
    title: 'Assessoria Aduaneira e Logística Importa Fácil Japão',
    category: 'Serviços & Assinaturas',
    priceJpy: 2500,
    image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=800&auto=format&fit=crop&q=80',
    condition: 'Assessoria Especializada',
    location: 'Depósito Saitama',
    weightKg: 0.0,
    stock: 999,
    rating: 5.0,
    reviewsCount: 7,
    salesCount: 85,
    orderIndex: 11,
    description: 'Suporte completo para desembaraço e envio via Importa Fácil dos Correios, com emissão de invoice internacional e conferência rigorosa de NCM.',
    tags: ['Importa Fácil', 'Aduana', 'Assessoria', 'Serviços'],
    featured: false
  },
  {
    id: 'importa-facil-china',
    title: 'Assessoria Importa Fácil China via Hub Logístico',
    category: 'Serviços & Assinaturas',
    priceJpy: 2800,
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&auto=format&fit=crop&q=80',
    condition: 'Assessoria Especializada',
    location: 'Hub Internacional',
    weightKg: 0.0,
    stock: 999,
    rating: 4.8,
    reviewsCount: 5,
    salesCount: 42,
    orderIndex: 12,
    description: 'Recebimento de produtos da China diretamente em nosso armazém parceiro com inspeção prévia de qualidade antes do despacho para o Brasil.',
    tags: ['China', 'Importa Fácil', 'Hub', 'Logística'],
    featured: false
  },
  {
    id: 'redirecionamento-da-china-para-o-japao',
    title: 'Redirecionamento de Cargas da China para o Depósito no Japão',
    category: 'Serviços & Assinaturas',
    priceJpy: 3200,
    image: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=800&auto=format&fit=crop&q=80',
    condition: 'Redirecionamento Internacional',
    location: 'Depósito Saitama',
    weightKg: 0.0,
    stock: 999,
    rating: 4.9,
    reviewsCount: 6,
    salesCount: 55,
    orderIndex: 13,
    description: 'Intermediação e consolidação de mercadorias vindas de fornecedores chineses até nosso depósito de Saitama, permitindo juntar pedidos da Ásia em um único envio para o Brasil.',
    tags: ['Redirecionamento', 'China', 'Japão', 'Consolidação'],
    featured: false
  },
  {
    id: 'francisco-box-2',
    title: 'Caixa de Consolidação Sob Demanda - Francisco Box 2',
    category: 'Envios Especiais',
    priceJpy: 1800,
    image: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=800&auto=format&fit=crop&q=80',
    condition: 'Embalagem Reforçada',
    location: 'Depósito Saitama',
    weightKg: 1.2,
    stock: 1,
    rating: 5.0,
    reviewsCount: 1,
    salesCount: 1,
    orderIndex: 14,
    description: 'Lote de consolidação personalizado com proteção tripla em plástico-bolha e cantoneiras rígidas.',
    tags: ['Consolidação', 'Envio', 'Personalizado'],
    featured: false
  },
  {
    id: 'suporte-para-uso-e-comunicacao-com-vendedor-no-leilao-da-yahoojapan-2',
    title: 'Suporte de Comunicação e Lances no Yahoo! Auctions Japan',
    category: 'Serviços & Assinaturas',
    priceJpy: 1500,
    image: 'https://images.unsplash.com/photo-1579226905180-636b76d96082?w=800&auto=format&fit=crop&q=80',
    condition: 'Serviço de Tradução & Negociação',
    location: 'Atendimento Online Japão',
    weightKg: 0.0,
    stock: 999,
    rating: 5.0,
    reviewsCount: 14,
    salesCount: 110,
    orderIndex: 15,
    description: 'Comunicação nativa em japonês diretamente com vendedores do Yahoo! Auctions e Mercari para tirar dúvidas sobre estado da peça, solicitar fotos extras e agilizar a postagem.',
    tags: ['Yahoo Auctions', 'Suporte', 'Tradução', 'Comunicação', 'leilao-japao', 'personal-shopper-no-japao'],
    featured: true
  }
];
